"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeneratableArrayInput = exports.ArrayInput = void 0;
var react_1 = require("react");
var jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable @typescript-eslint/no-explicit-any */
var formik_1 = require("formik");
var lodash_1 = __importDefault(require("lodash"));
var react_2 = require("react");
var react_i18next_1 = require("react-i18next");
var FormInput_1 = require("../../form/FormInput");
var ArrayInput = function (props) {
    var t = (0, react_i18next_1.useTranslation)().t;
    return ((0, jsx_runtime_1.jsx)(formik_1.FieldArray, { name: props.name, children: function (_a) {
            var remove = _a.remove, push = _a.push, form = _a.form;
            return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [lodash_1.default.get(form.values, props.name, { default: [] }).map(function (__, valueIndex) { return ((0, jsx_runtime_1.jsxs)(react_2.Fragment, { children: [(0, jsx_runtime_1.jsxs)("h2", { children: [t(props.label), " ", valueIndex + 1] }), (0, jsx_runtime_1.jsx)(props.ArrayElement, { children: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: props.elements.map(function (ele) {
                                        var input = FormInput_1.FormInputs.find(function (i) { return i.type === ele.type; });
                                        var name = "".concat(props.name, ".").concat(valueIndex, ".").concat(ele.props.name);
                                        return ((0, react_1.createElement)(input.Element, __assign({}, ele.props, { name: name, key: name, id: ele.props.id || ele.props.name })));
                                    }) }) }), (0, jsx_runtime_1.jsx)(props.RemoveElement, { onClick: function () { return remove(valueIndex); } }, "remove-".concat(valueIndex))] }, valueIndex)); }), (0, jsx_runtime_1.jsx)(props.AddElement, { onClick: function () { return push(props.initialValues); } })] }));
        } }));
};
exports.ArrayInput = ArrayInput;
exports.GeneratableArrayInput = {
    type: 'array',
    Element: exports.ArrayInput,
};
